import { cn } from "@theprelude/core";
import { forwardRef, InputHTMLAttributes } from "react";

export type SelectProps = InputHTMLAttributes<HTMLSelectElement>;

export const Select = forwardRef<HTMLSelectElement, SelectProps>(
  function Select({ className, ...props }, ref) {
    return (
      <select
        ref={ref}
        className={cn(
          "h-9 w-full appearance-none rounded border border-stroke-input bg-[position:center_right_0.5rem] bg-[url('/images/arrow.svg')] bg-surface-background bg-no-repeat px-3 py-2 pr-11 focus:border-primary-foreground focus:outline-none",
          className,
        )}
        {...props}
      />
    );
  },
);
